import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import FindForm from "./FindForm";

class CompanyFindForm extends React.Component {
  render() {
    return (
      <FindForm dataItem={this.props.transportReqSWFind}
                dataItemParams={this.props.transportReqSWFindParams}
                row={this.props.row}
                title={i18next.t("FindRequisitesTitle")}
                onClose={this.props.onClose}
                onSelect={this.props.onSelect}
      />
    );
  }
}

CompanyFindForm.propTypes = {
  dispatch: PropTypes.func,
  transportReqSWFind: PropTypes.object,
  transportReqSWFindParams: PropTypes.object,
  row: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    transportReqSWFind: state.transportState.transportReqSWFind,
    transportReqSWFindParams: state.transportState.transportReqSWFindParams
  };
};

export default connect(mapStateToProps)(CompanyFindForm);